import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { MistGuestWifiComponent } from '@app/features/mists/modules/guest-wifi/components/guest-wifi/guest-wifi.component';
import { MistSiteCardComponent } from '@app/features/mists/modules/guest-wifi/components/site-card/site-card.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        MistGuestWifiComponent,
        MistSiteCardComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class MistGuestWifiModule {}